import {createContext} from "react";

interface UserContextType {
    isUserSawBanner:boolean,
    setIsUserSawBanner:(value: React.SetStateAction<boolean>) => void,
    loadedUserInfo:boolean,
  
}

export const UserContext = createContext<UserContextType>({
    isUserSawBanner:false,
    loadedUserInfo:false,
    setIsUserSawBanner(value) {
    },
});